import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { PageNotfoundComponent } from './pages/page-not-found/page-not-found.component';
import { AuthGuard } from './authguard';

const routes: Routes = [
  {
    path: '', 
    redirectTo: 'home',
    pathMatch: 'full'
  },
  
  { path: 'home', component: HomeComponent },
  
  // pages
  { path: 'service-phone', loadChildren: () => import('./pages/service-phone/service-phone.module').then(m => m.ServicePhoneModule) },
  { path: 'download', loadChildren: () => import('./pages/download/download.module').then(m => m.DownloadModule)
  },
  { path: 'ios-download', loadChildren: () => import('./pages/ios-download/ios-download.module').then(m => m.IosDownloadModule) },
  { path: 'bank-list', loadChildren: () => import('./pages/bank-list/bank-list.module').then(m => m.BankListModule),
      canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'change-password', loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordModule),
      canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'holiday', loadChildren: () => import('./pages/holiday-list/holiday-list.module').then(m => m.HolidayListModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'invite-code', loadChildren: () => import('./pages/invite-code/invite-code.module').then(m => m.InviteCodeModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  //{ path: 'feedback', loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackModule) },
  { path: 'feedback', loadChildren: () => import('./pages/feedbackandfaqs/feedbackandfaqs.module').then(m => m.FeedbackandFaqsModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'userguide/:faqId', loadChildren: () => import('./pages/userguide/userguide.module').then(m => m.UserguideModule) },
  { path: 'feedback/:faq', loadChildren: () => import('./pages/feedbackandfaqs/feedbackandfaqs.module').then(m => m.FeedbackandFaqsModule) },

  // feature modules
  { path: 'notification', loadChildren: () => import('./modules/notification/notification.module').then(m => m.NotificationModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'promotion', loadChildren: () => import('./modules/promotion/promotion.module').then(m => m.PromotionModule),
      canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'profile', loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule),  
      // canActivate: [AuthGuard],
      // canLoad : [AuthGuard]
   },
  { path: 'twod', loadChildren: () => import('./modules/twod/twod.module').then(m => m.TwodModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'threed', loadChildren: () => import('./modules/threed/threed.module').then(m => m.ThreedModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'bet-history', loadChildren: () => import('./modules/bet-history/bet-history.module').then(m => m.BetHistoryModule),
      canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: 'winner', loadChildren: () => import('./modules/winner/winner.module').then(m => m.WinnerModule), 
      canActivate: [AuthGuard],
      canLoad: [AuthGuard] },
  { path: 'game', loadChildren: () => import('./modules/game/game.module').then(m => m.GameModule),
     canActivate: [AuthGuard],
    canLoad : [AuthGuard]
   },
  { path: 'wallet', loadChildren: () => import('./modules/wallet/wallet.module').then(m => m.WalletModule) ,
     canActivate: [AuthGuard],
     canLoad : [AuthGuard]
  },
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  { path: 'dotpsettings', loadChildren: () => import('./modules/default-otp-options/default-otp-options.module').then(m => m.DefaultOtpOptionsModule),
   },
  { path: 'dotpsettings/:url', loadChildren: () => import('./modules/default-otp-options/default-otp-options.module').then(m => m.DefaultOtpOptionsModule)

   },
  { path: 'emailSetting/', loadChildren: () => import('./modules/define-email/define-email.module').then(m => m.DefineEmailModule),
    canActivate: [AuthGuard],
    canLoad : [AuthGuard]
   },
  { path: 'emailSetting/:url', loadChildren: () => import('./modules/define-email/define-email.module').then(m => m.DefineEmailModule),
    canActivate: [AuthGuard],
    canLoad : [AuthGuard]
   },
  {
     path: 'verifyEmail', loadChildren: () => import('./modules/verify-email/verify-email.module').then(m => m.VerifyEmailModule),
     canActivate: [AuthGuard],
     canLoad : [AuthGuard]
   },
  { path: 'userpoint', loadChildren: () => import('./pages/userpoint/userpoint.module').then(m => m.UserpointModule),
     canActivate: [AuthGuard],
      canLoad : [AuthGuard]
   },
  { path: '**', component: PageNotfoundComponent }   
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,{ enableTracing: true, onSameUrlNavigation: 'reload' }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }